<template>
  <div id="top-header">
    <dv-decoration-8 class="header-left-decoration" />
    <dv-decoration-12   style="  position: absolute;" />
    <dv-decoration-5 class="header-center-decoration" />
    <dv-decoration-8 class="header-right-decoration" :reverse="true" />
    <div class="center-title">装配线生产看板</div>
  </div>
</template>

<script>
export default {
  name: "TopHeader",
};
</script>

<style lang="less">
#top-header {
  position: relative;

  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  .header-center-decoration {
    width: 64%;
    height: 60px;
    margin-top: 50px;
  }

  .header-left-decoration,
  .header-right-decoration {
    width: 18%;
    height: 60px;
  }

  .center-title {
    position: absolute;
    font-size: 39px;
    font-weight: bold;
    left: 50%;
    top: 15px;
    // font-family: '草檀斋毛泽东字体';
    transform: translateX(-50%);
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AndonHeader.vue